import React, { useState } from 'react';
import QuizInline from './QuizInline';
import styles from './QuizCard.module.css';

export default function QuizCard({ quiz }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={styles.card}>
      <div
        className={styles.header}
        onClick={() => setOpen(o => !o)}
        role="button"
        tabIndex={0}
      >
        <span className={styles.icon}>{open ? '−' : '+'}</span>
        <span className={styles.title}>
          Cuestionario
        </span>
      </div>
      {open && (
        <div className={styles.body}>
          <QuizInline questions={quiz.questions} />
        </div>
      )}
    </div>
  );
}
